<template>
    <v-footer dark padless>
        <v-layout align-center>
            <v-flex xs12>
                <v-card flat tile class="gray white--text text-center">
                    <v-card-text class="pb-8">
                        <v-btn v-for="imagem in imagens" :key="imagem" class="mx-4 white--text" icon>
                            <v-img :src="imagem" max-height="50" max-width="50" contain/>
                        </v-btn>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-text class="white--text pt-5">
                        <div class="hidden-xs hidden-sm caption font-weight-thin">
                            <strong class="font-weight-light d-none d-md-block">
                                AGETIC - Agência de Tecnologia da Informação e Comunicação
                                <br/>UFMS - Universidade Federal de Mato Grosso do Sul
                            </strong>
                            <strong class="font-weight-light d-xs-block d-md-none">
                                AGETIC - UFMS
                                <br/>
                            </strong>
                            <a href="https://agetic.ufms.br/?servico=passaporte-ufms" target="_blank"
                               rel="noopener noreferrer">Clique aqui</a> para mais informações sobre o Passaporte UFMS
                            <br/>Para obter suporte: (067) 3345-7292
                            <br/>Segunda a sexta das 07:00 às 11:00 - 13:00 às 17:00
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-footer>
</template>

<script>
    export default {
        name: "AppRodape",
        data: () => ({
            imagens: [
                require("../assets/logo-agetic-small.png"),
                require("../assets/logo-ufms.png")
            ]
        }),
    }
</script>

<style scoped>

</style>
